import { Typography } from '@/ui';

import type { PulseReportAnswer } from '@/types';
import type { FC } from 'react';

interface AnswerMultiSelectProps {
  answer: Extract<PulseReportAnswer, { kind: 'multi_select' }>;
}

const AnswerMultiSelect: FC<AnswerMultiSelectProps> = ({ answer }) => (
  <div className="flex flex-col gap-2">
    <Typography className="text-cement-600" variant="subtitle1">
      {answer.prompt}
    </Typography>
    <div
      className="rounded-xl border border-sage-200 bg-sage-100 px-4 py-3"
      data-testid="multi-select-selections"
    >
      {answer.selections.length ? (
        <ul className="list-disc space-y-2 pl-5">
          {answer.selections.map((selection) => (
            <li key={`${answer.id}-${selection}`}>
              <Typography color="text.secondary" variant="h5">
                {selection}
              </Typography>
            </li>
          ))}
        </ul>
      ) : (
        <Typography className="body text-cement-400">
          No selections provided.
        </Typography>
      )}
    </div>
  </div>
);

export default AnswerMultiSelect;
